module.exports = __webpack_public_path__ + "img/craftBannerPaverMobile.0aa0a76.webp";